export default "__VITE_ASSET__31f5bb52__"